module.exports = __webpack_public_path__ + "static/media/review_ic.33ce5659.svg";